import { render } from "./ProjectProgressAttachmentOffcanvas.vue?vue&type=template&id=4b2eff14&scoped=true&ts=true"
import script from "./ProjectProgressAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectProgressAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectProgressAttachmentOffcanvas.scss?vue&type=style&index=0&id=4b2eff14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2eff14"]])

export default __exports__